// 設定ファイル
import ConfigRepository from "./ConfigRepository";
import InfoRepository from "./InfoRepository";
import InundationRepository from "./InundationRepository";
import IuApiRepository from "./IuApiRepository";
import EvacuationJsonRepository from "./json/EvacuationJsonRepository";
import InfoJsonRepository from "./json/InfoJsonRepository";
import InundationJsonRepository from "./json/InundationJsonRepository";
import MapJsonRepository from "./json/MapJsonRepository";
import RadarJsonRepository from "./json/RadarJsonRepository";
import RiverWarnJsonRepository from "./json/RiverWarnJsonRepository";
// テスト用
// import RiverWarnTestRepository from "./test/RiverWarnTestRepository";
// import TelemeterTestRepository from "./test/TelemeterTestRepository";
// import TelemeterObsTestRepository from "./test/TelemeterObsTestRepository";
// import MapApiTestRepository from "./test/MapApiTestRepository";
// import RadarTestRepository from "./test/RadarTestRepository";
// import IuTestRepository from "./test/IuTestRepository";
// import InundationTestRepository from "./test/InundationTestRepository";
// import InfoTestRepository from "./test/InfoTestRepository";
// import ObsSearchTestRepository from "./test/ObsSearchTestRepository";
// JSON用
import SwinRepository from "./json/SwinJsonRepository";
import SystemJsonRepository from "./json/SystemJsonRepository";
import TelemeterJsonRepository from "./json/TelemeterJsonRepository";
import TelemeterObsJsonRepository from "./json/TelemeterObsJsonRepository";
import MapApiRepository from "./MapApiRepository";
import MapGeojsonRepository from "./MapGeojsonRepository";
import ObsSearchRepository from "./ObsSearchRepository";
import RadarGeojsonRepository from "./RadarGeojsonRepository";
import RadarRepository from "./RadarRepository";
import RiverWarnGeojsonRepository from "./RiverWarnGeojsonRepository";
import SystemDataRepository from "./systemDataRepository";
// 外部サーバ接続用
import RiverWarnRepository from "./RiverWarnRepository";
import TelemeterGeojsonRepository from "./TelemeterGeojsonRepository";
import TelemeterObsRepository from "./TelemeterObsRepository";
import TelemeterRepository from "./TelemeterRepository";
// アクセスログ(ページログ)出力用
import PageLogRepository from "./PageLogRepository";

// TODO 各ストア毎のリポジトリを追加する
const repositoryes = {
  // 設定ファイル
  config: ConfigRepository,

  // 外部サーバ接続用
  riverWarn: RiverWarnRepository,
  riverWarnGeojson: RiverWarnGeojsonRepository,
  telemeter: TelemeterRepository,
  telemeterObs: TelemeterObsRepository,
  telemeterGeojson: TelemeterGeojsonRepository,
  MapApi: MapApiRepository,
  MapGeojson: MapGeojsonRepository,
  radar: RadarRepository,
  radarGeojson: RadarGeojsonRepository,
  iu: IuApiRepository,
  inundation: InundationRepository,
  info: InfoRepository,
  obsSearch: ObsSearchRepository,

  // テスト用リポジトリ
  // config: ConfigTestRepository,
  // riverWarn: RiverWarnTestRepository,
  // telemeter: TelemeterTestRepository,
  // telemeterObs: TelemeterObsTestRepository,
  // MapApi: MapApiTestRepository,
  // radar: RadarTestRepository,
  // iu: IuTestRepository,
  // inundation: InundationTestRepository,
  // info: InfoTestRepository,
  // obsSearch: ObsSearchTestRepository,

  // JSON用リポジトリ
  swin: SwinRepository,
  riverWarnJson: RiverWarnJsonRepository,
  infoJson: InfoJsonRepository,
  mapJsonRepository: MapJsonRepository,
  telemeterJson: TelemeterJsonRepository,
  radarJson: RadarJsonRepository,
  telemeterObsJson: TelemeterObsJsonRepository,
  systemJson: SystemJsonRepository,
  evaInfo: EvacuationJsonRepository,
  inundationJson: InundationJsonRepository,
  systemData: SystemDataRepository,

  // アクセスログ(ページログ)出力用
  PageLog: PageLogRepository,
};

export const RepositoryFactory = {
  get: (name) => repositoryes[name],
};
